import { Link } from 'react-router-dom';
import './ItemsGuidePage.css';

const CATEGORIES = [
  {
    title: 'Fridges & Refrigeration',
    icon: '❄️',
    items: [
      'Fridges',
      'Fridge freezers',
      'Freezers',
      'Chest freezers',
      'American-style fridge freezers',
      'Commercial fridges',
      'Display fridges',
      'Drinks fridges and bottle coolers',
      'Refrigerated display cabinets',
      'Refrigeration units',
      'Air-conditioning units containing refrigerant',
      'Dehumidifiers containing refrigerant',
      'Refrigeration compressors or systems containing refrigerant',
    ],
  },
  {
    title: 'Gas Bottles & Pressurised Containers',
    icon: '🧯',
    items: [
      'Gas bottles',
      'LPG cylinders',
      'Propane cylinders',
      'Butane cylinders',
      'Camping gas bottles',
      'Patio gas bottles',
      'Industrial gas cylinders',
      'Oxygen cylinders',
      'Acetylene cylinders',
      'CO₂ cylinders',
      'Helium cylinders',
      'Refrigerant cylinders',
      'Diving cylinders',
      'Fire extinguishers',
      'Pressurised tanks',
      'Unidentified cylinders',
    ],
  },
  {
    title: 'Tyres',
    icon: '🛞',
    note: 'Bare alloy and steel wheels without tyres may be accepted as scrap metal.',
    items: [
      'Car tyres',
      'Van tyres',
      'Truck tyres',
      'Motorcycle tyres',
      'Tractor tyres',
      'Commercial tyres',
      'Loose tyres',
      'Alloy wheels with tyres attached',
      'Steel wheels with tyres attached',
      'Motorcycle wheels with tyres attached',
    ],
  },
  {
    title: 'Shopping Trolleys & Third-Party Property',
    icon: '🛒',
    items: [
      'Supermarket shopping trolleys',
      'Retail roll cages',
      'Supermarket cages',
      'Delivery cages belonging to retailers',
      'Milk trolleys',
      'Brewery-owned beer kegs',
      'Supplier-owned gas cylinders',
      'Council barriers',
      'Road signs',
      'Traffic signs',
      'Street signs',
      'Manhole covers',
      'Drain covers from public roads',
      'Street furniture',
      'Council bins',
      'Utility-company equipment',
      'Telecom equipment',
      'Railway equipment',
      'Public infrastructure',
      'Any item that does not belong to the person posting it',
    ],
  },
  {
    title: 'Hazardous Materials',
    icon: '☣️',
    items: [
      'Asbestos',
      'Asbestos sheets',
      'Asbestos roofing',
      'Asbestos insulation',
      'Chemicals',
      'Pesticides',
      'Herbicides',
      'Solvents',
      'Paint stripper',
      'Petrol',
      'Diesel',
      'Paraffin',
      'Creosote',
      'Antifreeze',
      'Brake fluid',
      'Contaminated oil',
      'Engine oil',
      'Unknown liquids',
      'Chemical containers containing residue',
      'Contaminated metal containers',
    ],
  },
  {
    title: 'Fuel, Oil & Chemical Tanks',
    icon: '🛢️',
    items: [
      'Fuel tanks containing fuel',
      'Petrol tanks containing petrol',
      'Diesel tanks containing diesel',
      'Heating-oil tanks containing oil',
      'Hydraulic tanks containing fluid',
      'Chemical tanks',
      'Contaminated drums',
      'Oil drums containing oil',
      'Chemical barrels',
      'IBC containers containing chemicals',
      'Tanks or containers with unknown contents',
    ],
  },
  {
    title: 'Vehicles',
    icon: '🚘',
    note: 'Individual clean metal vehicle parts may be accepted where suitable.',
    items: [
      'Complete cars',
      'Scrap cars',
      'Complete vans',
      'Motorcycles',
      'Mopeds',
      'Caravans',
      'Vehicles containing fuel or fluids',
      'Undepolluted end-of-life vehicles',
    ],
  },
  {
    title: 'Batteries We Don’t Accept',
    icon: '🔋',
    items: [
      'Damaged lithium batteries',
      'Lithium-ion battery packs',
      'E-bike batteries',
      'Electric scooter batteries',
      'Electric vehicle batteries',
      'Hybrid vehicle batteries',
      'Industrial battery banks',
      'Swollen batteries',
      'Leaking batteries',
      'Damaged power-tool batteries',
      'Loose household batteries',
    ],
  },
  {
    title: 'TVs, Computers & General Electronics',
    icon: '📺',
    items: [
      'TVs',
      'Computer monitors',
      'Desktop computers',
      'Laptops',
      'Tablets',
      'Printers',
      'Photocopiers',
      'Games consoles',
      'Routers',
      'Telephones',
      'Small household electronics',
      'Fluorescent tubes',
      'Mercury lamps',
    ],
  },
  {
    title: 'General Household Waste',
    icon: '🗑️',
    items: [
      'Black bags',
      'Household rubbish',
      'Food waste',
      'Cardboard',
      'Paper',
      'Plastic',
      'Packaging',
      'Glass',
      'Bottles',
      'Clothes',
      'Shoes',
      'Toys',
      'Mixed household waste',
      'General clearance waste',
    ],
  },
  {
    title: 'Furniture & Non-Metal Household Items',
    icon: '🛋️',
    items: [
      'Sofas',
      'Armchairs',
      'Mattresses',
      'Divan bases',
      'Fabric furniture',
      'Wooden beds',
      'Wooden wardrobes',
      'Wooden drawers',
      'Wooden tables',
      'Wooden chairs',
      'Carpets',
      'Rugs',
      'Curtains',
      'Plastic furniture',
      'Wooden cabinets',
    ],
  },
  {
    title: 'Building & Renovation Waste',
    icon: '🧱',
    items: [
      'Bricks',
      'Concrete',
      'Rubble',
      'Hardcore',
      'Plasterboard',
      'Plaster',
      'Cement',
      'Roof tiles',
      'Ceramic tiles',
      'Insulation',
      'Fibreglass',
      'Roofing felt',
      'Glass',
      'Soil',
      'Timber',
      'Wooden doors',
      'Plastic pipes',
      "Mixed builders' waste",
    ],
  },
  {
    title: 'Bathroom Items That Aren’t Metal',
    icon: '🚿',
    note: 'Metal items such as cast-iron baths, stainless-steel sinks and metal shower trays may be accepted.',
    items: [
      'Toilets',
      'Ceramic sinks',
      'Ceramic basins',
      'Ceramic baths',
      'Plastic baths',
      'Plastic shower trays',
      'Glass shower screens',
      'Bathroom tiles',
    ],
  },
  {
    title: 'Garden & Outdoor Waste',
    icon: '🌿',
    note: 'Metal sheds, metal fencing, gates and metal garden furniture may be accepted.',
    items: [
      'Trees',
      'Branches',
      'Grass',
      'Leaves',
      'Soil',
      'Compost',
      'Wooden fencing',
      'Wooden sheds',
      'Plastic sheds',
      'Plastic garden furniture',
      'Wooden garden furniture',
      'Plant pots',
      'Plastic water butts',
      'Garden chemicals',
    ],
  },
  {
    title: 'Sealed or Unidentified Items',
    icon: '⚠️',
    items: [
      'Sealed drums',
      'Sealed barrels',
      'Unknown tanks',
      'Unknown cylinders',
      'Unlabelled chemical containers',
      'Containers containing unknown liquids',
      'Machinery leaking oil or other fluids',
      'Sealed pressure vessels',
      'Any item containing an unidentified substance',
    ],
  },
];

export default function ItemsWeDontTakePage() {
  return (
    <div className="items-guide-page">
      <section className="items-guide-hero is-reject" aria-labelledby="items-dont-heading">
        <div className="items-guide-hero-inner">
          <p className="items-guide-kicker">Not accepted</p>
          <h1 id="items-dont-heading">Items we don&apos;t take</h1>
          <p>
            SnapScrap is designed specifically for recyclable scrap metal. To keep collections safe,
            simple and suitable for our collector network, we do not accept the following items.
          </p>
          <div className="items-guide-hero-actions">
            <Link className="items-guide-btn" to="/items-we-take">
              See items we take
            </Link>
            <Link className="items-guide-btn items-guide-btn-secondary" to="/contact">
              Ask a question
            </Link>
          </div>
        </div>
      </section>

      <section className="items-guide-section" aria-labelledby="items-dont-list-heading">
        <div className="items-guide-inner items-guide-inner-wide">
          <header className="items-guide-header">
            <h2 id="items-dont-list-heading">Materials we cannot collect</h2>
            <p>Please arrange these through the right waste or recycling service instead</p>
          </header>

          <div className="items-take-categories">
            {CATEGORIES.map((category) => (
              <article key={category.title} className="items-take-category">
                <h3>
                  <span aria-hidden="true">{category.icon}</span> {category.title}
                </h3>
                {category.note ? <p className="items-take-note">{category.note}</p> : null}
                <ul>
                  {category.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <p className="items-guide-note">
            If your pile is mixed, remove non-metal waste first or note it clearly in your post so
            collectors know what to expect.
          </p>
        </div>
      </section>

      <section className="items-guide-cta" aria-labelledby="items-dont-cta-heading">
        <h2 id="items-dont-cta-heading">Got scrap metal instead?</h2>
        <p>Post your metal items and get matched with a licensed collector near you.</p>
        <div className="items-guide-hero-actions">
          <Link className="items-guide-btn" to="/post-scrap">
            Post Scrap →
          </Link>
          <Link className="items-guide-btn items-guide-btn-secondary" to="/items-we-take">
            Items we take
          </Link>
        </div>
      </section>
    </div>
  );
}
